import { render, staticRenderFns } from "./LatestPayments.vue?vue&type=template&id=883c7a9c&"
import script from "./LatestPayments.vue?vue&type=script&lang=js&"
export * from "./LatestPayments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports